import { useEffect } from 'react'
import ReactGA from 'react-ga'

const GoogleAnalytics = ({ serverProperties, location }) => {
  const trackingId = (lgyUrl) => {
    switch (lgyUrl) {
      case 'https://int.lgy.va.gov': return 'UA-76628442-31'
      case 'https://pint.lgy.va.gov': return 'UA-76628442-35'
      case 'https://sqa.lgy.va.gov': return 'UA-76628442-32'
      case 'https://preprod.lgy.va.gov': return 'UA-76628442-33'
      case 'https://lgy.va.gov': return 'UA-76628442-34'
      default: return null
    }
  }

  useEffect(() => {
    if (serverProperties.lgyUrl === 'https://local.lgy.va.gov:8081') {
      //show debug info on locals, feel free to comment out if it's annoying
      ReactGA.initialize('foo', { debug: true })
    } else if (serverProperties.lgyUrl) {
      ReactGA.initialize(trackingId(serverProperties.lgyUrl))
    }
  }, [serverProperties.lgyUrl])

  useEffect(() => {
    if (ReactGA.ga()) {
      ReactGA.pageview(location.pathname)
    }
  }, [location.pathname])

  return null
}

export default GoogleAnalytics